import React from 'react'
import FormDialog from './FormDialog'

const Edit = ({title,Dialog,params,submit,close,version,setVersion}) => {

    return (
        <div className='flex w-full h-full items-center justify-center bg-[rgba(0,0,0,.85)]'>
            <FormDialog title={title} onSubmit={submit} onClose={close} version={version} setVersion={setVersion}>
                {Dialog && <Dialog params={params}/>}
            </FormDialog>
        </div>
    )
}

export default Edit